import './FacebookIcn.css';
import FacebookImage from '../../../assets/image/facebook.png';

const FacebookIcon = () => {
    return ( 
        <div className="facebookicon">
            <img src={ FacebookImage } alt="facebook-icon" />
        </div>
     );
}
 
export default FacebookIcon;